module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_page"
  }, [_c('el-row', {
    staticClass: "tac"
  }, [_c('el-col', {
    staticClass: "nav",
    attrs: {
      "span": 4
    }
  }, [_c('el-menu', {
    staticStyle: {
      "min-height": "100%",
      "text-align": "left"
    },
    attrs: {
      "default-active": _vm.defaultActive,
      "theme": "dark",
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "welcome"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-gonggao icon"
  }), _vm._v("首页")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "xmlx"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-shuzi1 icon"
  }), _vm._v("题目")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "problemList"
    }
  }, [_vm._v("题目列表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "createProblem"
    }
  }, [_vm._v("出题")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "prepareProblemList"
    }
  }, [_vm._v("待审核题目")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "prepareProblemListUser"
    }
  }, [_vm._v("用户提交的题目")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "gzfa"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-shuzi2 icon"
  }), _vm._v("相关知识")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "knowledgeList"
    }
  }, [_vm._v("知识列表")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "xmss"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-shuzi3 icon"
  }), _vm._v("辅助功能")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "managerPage"
    }
  }, [_vm._v("管理页面")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "noticePage"
    }
  }, [_vm._v("公告管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "upload2Oss"
    }
  }, [_vm._v("上传资源到OSS")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "newTeamList"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weibiaoti1 icon"
  }), _vm._v("新团队审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "jhxm"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weibiaoti1 icon"
  }), _vm._v("注册人数统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "txxt"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tuxing icon"
  }), _vm._v("用户分析")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "yjjy"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tuxing icon"
  }), _vm._v("意见建议")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "height": "calc(100vh - 56px)",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "span": 20
    }
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "animated fadeInLeft",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [_c('router-view', {
    staticClass: "router"
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-086751ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = 629
// module chunks = 12